
import { Options, Vue } from 'vue-class-component';
import PackageVersions from '@/components/PackageVersions.vue';

@Options({
  components: {
    PackageVersions
  }
})
export default class About extends Vue {

  mounted() {
    //
  }
}
